import React from "react";
import { useApiResponse } from "../context/ApiResponseContext";

function Alert({ type = "success", text }) {
  let alertClassName = "alert-success";
  if (type === "error") {
    alertClassName = "alert-error";
  }
  const [apiError, setApiError] = useApiResponse();

  const handleCloseAlert = () => {
    const tempApiErrors = { ...apiError };
    Object.entries(apiError).map(([key, value]) => {
      if (value === text) {
        delete tempApiErrors[key];
        setApiError(tempApiErrors);
      }
    });
  };

  return (
    <div className={"flexWrapper " + alertClassName}>
      <h3>{text}</h3>
      <i onClick={handleCloseAlert} class="fa-solid fa-circle-xmark"></i>
    </div>
  );
}

export default Alert;
